import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import Services from '../views/Services.vue';
// import Culture from '../views/Culture.vue';
import About from '../views/About.vue';
import Cooperation from '../views/joinUs.vue';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: { messageKey: 'h.home' }
        },
        {
            path: '/services',
            name: 'services',
            component: Services,
            meta: { messageKey: 'h.services' }
        },
        // {
        //     path: '/culture',
        //     name: 'culture',
        //     component: Culture,
        //     meta: { messageKey: 'h.culture' }
        // },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: { messageKey: 'h.about' }
        },
        {
            path: '/joinUs',
            name: 'join us',
            component: Cooperation,
            meta: { messageKey: 'h.cooperation' }
        }
    ]
});